module.exports = __webpack_public_path__ + "img/code.afc51466.png";